import { ApolloClient, InMemoryCache } from "@apollo/client"

export function createApolloClient(token = null) {
  let uri = `${process.env.NEXT_PUBLIC_API_URL}/graphql`
  if (token) {
    uri += `?token=${token}`
  }

  return new ApolloClient({
    uri,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    },
  })
}

// fetch data from api url
export const apollo = createApolloClient()
